import { render } from "./DynamicHtmlH2.vue?vue&type=template&id=0a5a164c&ts=true"
import script from "./DynamicHtmlH2.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlH2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlH2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a5a164c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a5a164c', __exports__)) {
    api.reload('0a5a164c', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlH2.vue?vue&type=template&id=0a5a164c&ts=true", () => {
    api.rerender('0a5a164c', render)
  })

}


export default __exports__